export default __webpack_public_path__ + "static/media/empty.f29aa41f.png";